import React from 'react'
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      border: 'solid 1px rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
)
interface SummaryViewProps {
  summary: string[]
}

export default function SummaryView(props: SummaryViewProps) {
  const { summary = [] } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className="flex-column">
        {summary?.length ? (
          summary.map((item, index) => (
            <div key={`summary-${index}`} className={classes.item}>
              {item}
            </div>
          ))
        ) : (
          <div className="p-2">No summary found</div>
        )}
      </div>
    </div>
  )
}
